const PBI_DASHBOARD_EMAILS = new Set([
  "adrian_moisa@crgl-thirdparty.com",
  "guilhem_servet@cargill.com",
]);

export const canAccessPbiDashboards = (email: string | null | undefined): boolean =>
  PBI_DASHBOARD_EMAILS.has(String(email ?? "").trim().toLowerCase());
